import BaseForm from '../base';
import { ObjectPanelComponent, LatLongColumnsComponent } from '../components';
export class EarthquakesForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'Limit',
                key: 'limit',
                type: 'number',
            },
            new ObjectPanelComponent({
                label: 'Magnitude',
                key: 'mag',
                components: [
                    {
                        label: 'Min',
                        key: 'min',
                        type: 'number',
                    },
                    {
                        label: 'Max',
                        key: 'max',
                        type: 'number',
                    }
                ]
            }),
            new ObjectPanelComponent({
                label: 'Distance',
                key: 'distance',
                type: 'container',
                components: [
                    {
                        label: 'Value',
                        key: 'value',
                        type: 'number',
                    },
                    {
                        label: 'Units',
                        key: 'units',
                        type: 'textfield',
                    }
                ]
            }),
        ];
    }
}
